<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <div class="content-box">
        <p style="font-size: 12px; color: #909399; margin-top: 20px">
          筛选月份可查看发放历史
        </p>
        <div class="select-box">
          <el-row :gutter="20">
            <el-col :span="24" :md="4" class="mb-1">
              <unitSearch style="width: 100%" @submitUnitId="submitUnitId" />
            </el-col>
            <el-col :span="24" :md="4" class="mb-1">
              <el-date-picker v-model="timeVal" size="medium" value-format="yyyy-MM" type="month" placeholder="选择月" style="width: 100%" />
            </el-col>
            <el-col :span="24" :md="16" class="mb-1" align="right">
              <el-button type="primary" size="medium" @click="searchTableData">
                筛选
              </el-button>
              <el-button type="primary" size="medium" @click="creatStudentEcxl">
                生成报表
              </el-button>
              <router-link :to="{name:'repeatList',query: {unitName: '查看名单中存在的重复学生',month:timeVal}}" style="color:#409EFF;font-size:12px;margin-top:10px;text-decoration: none;display:block;">
                查看名单中存在的重复学生
              </router-link>
            </el-col>
          </el-row>
        </div>
        <div class="table-box">
          <el-table :data="tableData" class="responsive">
            <el-table-responsive-column type="index" label="序号" />
            <el-table-responsive-column prop="unitName" label="用工单位" />
            <el-table-responsive-column prop="adminNumber" label="管理员人数" />
            <el-table-responsive-column prop="yearMonth" label="统计年月" />
            <el-table-responsive-column prop="studentCount" label="报酬发放人数" />
            <!-- <el-table-column prop="submitMoney" label="上报薪资总额">
        </el-table-column>
        <el-table-column prop="checkStatus" label="审核状态">
          <template slot-scope="scope">
            <span>{{scope.row.checkStatus === 1 ? '待审核' : '已完成'}}</span>
          </template>
        </el-table-column> -->
            <el-table-responsive-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row)">
                  填报工资
                </el-button>
                <!-- <el-button type="text" @click=toDetail(scope.row)>{{scope.row.checkStatus === 1 ? '审核' : '查看'}}</el-button> -->
              </template>
            </el-table-responsive-column>
          </el-table>
          <el-pagination style="float: right" :current-page="currentPage" :page-size="10" layout="total, prev, pager, next" :total="totalPages" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { salaryService, unitService } from '@/api/index'
import unitSearch from '@/components/UnitSearch.vue'

export default {
  name: 'ProvideList',
  components: { unitSearch },
  data() {
    return {
      unitList: [],
      unitVal: null,
      timeVal: null,
      tableData: [],
      currentPage: 1,
      totalPages: 0,
    }
  },
  created() {
    // 获取当前时间的上一月
    this.timeVal = this.$moment().subtract(0, 'month').format('YYYY-MM')
    this.initPage()
  },
  methods: {
    initPage() {
      unitService()._getAllunits().then(res => {
        if (res.status) {
          this.unitList = res.data
          this.unitList.unshift({ id: null, name: ' 不限用工单位' })
        }
      })
      this.queryPage()
    },
    creatStudentEcxl() {
      salaryService()._ReportStudentExcl(this.timeVal).then(res => {
        if (res.status) {
          this.searchTableData()
          this.$message.success('生成报表成功！')
        }
      })
    },
    submitUnitId(id) {
      this.unitVal = id
    },
    searchTableData() {
      this.currentPage = 1
      this.queryPage()
    },
    queryPage() {
      const params = {
        page: this.currentPage,
        size: 10,
        time: this.timeVal,
        unitId: this.unitVal,
      }
      salaryService()._schoolSalaryListIn(params).then(res => {
        if (res.status) {
          this.tableData = res.data.list
          this.totalPages = res.data.total
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryPage()
    },
    toDetail(row) {
      this.$router.push({ name: 'fillSalaryDeatail', query: { unitName: row.unitName, id: row.unitId, time: row.yearMonthStr } })
    },
  },
}
</script>

<style scoped>
</style>
